import baseAPI from '@/api';
import { UserRewardTracker } from '@/models/user-reward/tracker';
import { AxiosResponse } from 'axios';

export async function fetchUserRewardsTracker(): Promise<
  Array<UserRewardTracker>
> {
  try {
    const response: AxiosResponse<Array<UserRewardTracker>> = await baseAPI.get<
      Array<UserRewardTracker>
    >('/user-rewards/trackers');

    return response.data;
  } catch (error) {
    return null;
  }
}
